import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Card, Badge } from "../../components/ui/Card";

export default function LoyaltyCards() {
  const [cards, setCards] = useState([]);
  const [points, setPoints] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([api.get("/loyalty/cards"), api.get("/loyalty/points")])
      .then(([c, p]) => {
        setCards(c.data);
        setPoints(p.data);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p className="text-muted-foreground">Loading…</p>;

  return (
    <div>
      <h1 className="mb-4 font-montserrat text-2xl font-bold text-slate-900">Loyalty cards</h1>

      {cards.length === 0 ? (
        <p className="text-muted-foreground">
          No stamp cards yet — they appear here once a business you visit runs a loyalty program.
        </p>
      ) : (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {cards.map((c) => (
            <Card key={c.id} className="overflow-hidden">
              <div className="brand-gradient p-4 text-white">
                <p className="text-sm opacity-80">{c.program?.business?.name}</p>
                <p className="font-montserrat text-lg font-bold">{c.program?.reward_title}</p>
              </div>
              <div className="p-4">
                <div className="mb-2 flex flex-wrap gap-1.5">
                  {Array.from({ length: c.program?.stamps_required || 10 }).map((_, i) => (
                    <div
                      key={i}
                      className={`flex h-8 w-8 items-center justify-center rounded-full border text-xs font-bold ${
                        i < c.stamps_collected ? "border-primary bg-primary text-white" : "border-border text-muted-foreground"
                      }`}
                    >
                      {i + 1}
                    </div>
                  ))}
                </div>
                <div className="flex items-center justify-between">
                  <p className="text-sm text-muted-foreground">
                    {c.stamps_collected}/{c.program?.stamps_required} collected
                  </p>
                  <Badge variant={c.status === "completed" ? "accent" : "default"}>{c.status}</Badge>
                </div>
              </div>
            </Card>
          ))}
        </div>
      )}

      {points.length > 0 && (
        <div className="mt-8">
          <h2 className="mb-3 font-montserrat text-lg font-bold text-slate-900">Points</h2>
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            {points.map((p) => (
              <Card key={p.id} className="flex items-center justify-between p-4">
                <span className="font-medium text-slate-900">{p.business?.name}</span>
                <span className="font-bold text-primary">{p.points} pts</span>
              </Card>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
